import React, { Component } from 'react';

class HoneyPot extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id={this.props.nameField + '_wrap'} style={{display: 'none'}}>
                <input
                    type="text"
                    name={this.props.nameField}
                    className={'input-' + this.props.nameField}
                    value={this.props.nameValue}
                    onChange={this.props.handleChange}
                    id={this.props.nameField}
                />
            </div>
        );
    }

}

export default HoneyPot;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/HoneyPot.js